import React, { useEffect, Fragment, useState } from "react"
import { Container, Tab, Button, Tabs, Row, Col } from "react-bootstrap"
import NavBarUser from "../../components/shared/NavBarUser"
import { withRouter } from "react-router-dom"
import { getInformePadron, getPadron } from "../../services/user.service"
import Loader from "../../components/shared/Loader"
import TableUsersRegistrados from "../../components/tricel/TableUsersRegistrados"
import TableUsersRef from "../../components/tricel/TableUsersRef"
import { toast } from "react-toastify"


const Padron = ({ location, history }) => {
	const { votacion } = location
	const [users, setUsers] = useState([])
	const [usersRef, setUsersRef] = useState([])
	const [loader, setLoader] = useState()

	const checkIfUserExists = (rut) => {
		return (
			usersRef.filter(x => x.run_user.toString() === rut.toString()).length > 0 ||
			users.filter(x => x.run.toString() === rut.toString()).length > 0
		)
  }

		const getInformePdf = async () => {
			setLoader(true)
			console.log("Get informa pedron")
	 		toast.info("Generando archivo...")
			const response = await getInformePadron(votacion.id)
			console.log(response)
			if (response?.status === 200) {
				const url = window.URL.createObjectURL(new Blob([response.data]))
				const link = document.createElement("a")
				link.href = url
				link.setAttribute("download", `Padron_${votacion.nombre}_${Date.now()}.pdf`)
				document.body.appendChild(link)
				link.click()
			} 
			setLoader(false)
		}
	
	const getUsuarios = async () => {
		setLoader(true)
		const res = await getPadron(votacion.id)
		console.log(res)
		setUsers(res.data.usuarios_padron_actual)
		setUsersRef(res.data.usuarios_padron_esperado)
		setLoader(false)
	}
	useEffect(() => {
		if (votacion) {
			getUsuarios()
		}
	}, [votacion])

	return (
		<Fragment>
			<NavBarUser />
			<Container className="mt-4">
				<h1>Padron Electoral</h1>
				<h4>Votacion: {votacion.nombre}</h4>
				<h4>Unidad: {votacion.unidad.nombre}</h4>
				<hr />
				{loader ? (
					<Loader />
				) : (
					<Tabs defaultActiveKey="users">
						<Tab eventKey="users" title="Padrón Actual">
							<TableUsersRegistrados users={users} setUsers={setUsers} />
						</Tab>
						<Tab eventKey="usersRef" title="Padrón Esperado">
							<TableUsersRef
								users={usersRef}
								setUsers={setUsersRef}
								unidad={votacion.unidad_id}
								refreshData={getUsuarios}
								userExists={checkIfUserExists}
							/>
						</Tab>
					</Tabs>
				)}
				<hr />
				{!loader && (
					<Row className="justify-content-center">
						<Col lg={3}>
							<Button variant="secondary" block onClick={() => history.goBack()}>
								Volver
							</Button>
						</Col>
						<Col lg={3}>
							<Button variant="info" block onClick={getInformePdf}>
								Generar PDF
							</Button>
						</Col>
					</Row>
				)}
			</Container>
		</Fragment>
	)
}

export default withRouter(Padron)
